import React from 'react';
import { Text, TextStyle } from 'react-native';
import { cln } from '../../utils/classnames';

interface Props {
  text: string;
  search?: string;
  className?: string;
  style?: TextStyle;
  highlightStyle?: TextStyle;
}

const HighlightText: React.FC<Props> = ({ text, search, className, style, highlightStyle }) => {
  if (!search) {
    return (
      <Text className={cln(className)} style={style}>
        {text}
      </Text>
    );
  }

  const index = text.toLowerCase().indexOf(search.toLowerCase());

  if (index === -1) {
    return (
      <Text className={className} style={style}>
        {text}
      </Text>
    );
  }

  const before = text.slice(0, index);
  const match = text.slice(index, index + search.length);
  const after = text.slice(index + search.length);

  return (
    <Text className={className} style={style}>
      {before}
      <Text className={cln('bg-primary-600 dark:bg-primary-500', className)} style={highlightStyle}>
        {match}
      </Text>
      {after}
    </Text>
  );
};

export default HighlightText;
